import React from 'react';
import styles from './index.module.scss';

// Components
import SpecialForm from './Form';
import SpecialList from './SpecialList';

const SpecialsScreen = (props) => {
    return (
        <section className={styles.SpecialScreen}>
            <h4 className={styles.Title}>Specials</h4>
            <SpecialList />
            <SpecialForm />
        </section>
    );
};

export default SpecialsScreen;